<template>
	<div class="container">
		<van-sticky>
		<div class="nav_box">
			<div class="left_box">
				<div style="display: inline-block;" @mouseover="navShow = false"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="logo" src="@/assets/img_public/logo.png" @click="goIndex" />
				</div>
				<div class="nav_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div
						v-for="(value, index) in navList"
						:key="index"
						class="nav_el"
						:class="nowNav == value.title ? 'actived' : ''"
						@mouseover="navMouseover(value)"
						@click="oneNavClick(value)"
					>{{ value.title }}</div>
				</div>
			</div>
			<div class="right_box" @mouseover="navShow = false"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img_public/icon_search.webp" style="width: 32px;position: relative;top: 5px;cursor: pointer;" @click="searchClick" />
				<div class="lang_box">
					<div class="actived" style="border-right: 1px solid #E3E1E6;">EN</div>
					<div @click="goCN">CN</div>
				</div>
			</div>
		</div>
		</van-sticky>
		<!--搜索-->
		<div v-if="searchShow" class="search_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<div class="search_main">
				<div class="search_el">
					<van-icon name="close" size="30px" color="#A50073" class="icon_close" @click="searchShow = false" />
					<van-icon name="search" size="20px" color="#999999" class="icon_left" />
					<input v-model="searchVal" ref="searchDom" :placeholder="$t('nav.text1')" @keyup.enter="goSearch" />
					<van-icon name="down" size="22px" color="#A50073" class="icon_right" @click="goSearch" />
				</div>
			</div>
		</div>
		<!--搜索-->
		<!--导航-->
		<div v-if="navShow" class="nav_show_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<!--非产品-->
			<div
				v-if="!isProducts"
				class="nav_other"
				@mouseleave="navChildleave"
			>
				<div v-for="(value, index) in otherList" :key="index" @click="oneNavClick(value, true)">{{ value.title }}</div>
			</div>
			<!--非产品-->
			<!--产品-->
			<div
				v-if="isProducts"
				class="nav_products"
				@mouseleave="navChildleave"
			>
				<div class="product_box">
					<div class="title">{{ $t('nav.text3') }}</div>
					<div class="product_box_box">
						<div v-for="(value, index) in certificationsList" :key="index" class="product_el" @click="goProduct(value)">{{ value.title }}</div>
					</div>
				</div>
				<div class="product_box">
					<div class="title">{{ $t('nav.text2') }}</div>
					<div class="product_box_box">
						<div v-for="(value, index) in categoryList" :key="index" class="product_el" @click="goProduct2(value)">{{ value.title }}</div>
					</div>
				</div>
			</div>
			<!--产品-->
		</div>
		<!--导航-->
	</div>
</template>

<script>
export default {
	props: ['pageName'],
	components:{
		//
	},
	data() {
		return {
			nowNav: this.pageName,  //当前选中导航
			navList: [],
			searchShow: false,  //搜索弹框
			searchVal: '',  //搜索值
			navShow: false,  //导航弹框
			otherList: [],  //二级导航非产品数据
			certificationsList: [],  //产品认证数据
			categoryList: [],  //产品分类数据
			isProducts: false,  //二级导航是否为产品
			lang: sessionStorage.getItem('lang')
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'));
			//赋值默认产品导航分类
			that.categoryList = that.navList[1].children.cate_list;
			that.certificationsList = that.navList[1].children.cert_list;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击跳转CN
		goCN() {
			window.open('https://coretests.cn/');
		},
		//点击跳转产品
		goProduct2(value) {
			let that = this;
			if(that.$route.path == '/product-list.html') {
				that.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}else {
				that.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
			}
		},
		//点击跳转产品
		goProduct(value) {
			let that = this;
			if(that.$route.path == '/product-list.html') {
				that.$router.push({ path: '/product-list.html', query: { cert_ids: value.id, } });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}else {
				that.$router.push({ path: '/product-list.html', query: { cert_ids: value.id, } });
			}
		},
		//点击首页
		goIndex() {
			if(this.$route.path != '/') {
				this.$router.push({ path: '/' });
			}else {
				window.location.reload();
			}
		},
		//一级导航点击
		oneNavClick(value, value2) {
			let that = this;
			if(that.$route.path != value.url) {
				if(value.route == 'JobList') {
					if(that.$route.name === value.route) {
						that.$router.push({ path: '/job/'+value.url });
						window.location.reload();
					}else {
						that.$router.push({ path: '/job/'+value.url });
					}
				}else {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
							}
						}
					}else {
						that.$router.push({ path: value.url });
					}
				}
			}else {
				window.location.reload();
			}
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.searchShow = true;
			setTimeout(() => {
				that.$refs.searchDom.focus();
			}, 400);
		},
		//点击搜索确定
		goSearch() {
			let that = this;
			if(that.searchVal) {
				that.$router.push({ path: '/search.html', query: { search: that.searchVal, } });
			}else {
				that.$toast(that.$t('nav.text4'));
			}
		},
		//导航滑入
		navMouseover(value) {
			let that = this;
			if(value.url != '/') {
				if(value.url == '/product.html') {
					that.navShow = true;
					that.isProducts = true;
				}else if(value.url == '/support/support.html'){
					that.otherList = []
					that.navShow = false;
					that.isProducts = false;
				}else {
					that.otherList = value.children;
					that.navShow = true;
					that.isProducts = false;
				}
			}else {
				that.navShow = false;
				that.isProducts = false;
			}
		},
		//子导航滑出
		navChildleave() {
			let that = this;
			that.navChildShow = false;
			that.navShow = false;
			that.isProducts = false;
		},
	}
}
</script>

<style lang="less" scoped>
.nav_show_box{
	width: 100%;
	height: calc(100vh - 90px);
	position: fixed;
	top: 90px;
	left: 0;
	background-color: rgba(0,0,0,.7);
	z-index: 999;
	.nav_products{
		background-color: #ffffff;
		height: 65vh;
		padding: 40px 120px;
		overflow: auto;
		.product_box{
			padding-bottom: 30px;
			.product_box_box{
				.product_el{
					display: inline-block;
					margin: 0 30px 40px 0;
					padding: 8px 14px;
					font-size: 18px;
					background-color: #F7F6F9;
					border-radius: 8px;
					cursor: pointer;
				}
				.product_el:hover{
					color: #A50073;
				}
			}
			.title{
				font-size: 22px;
				font-weight: bold;
				margin-bottom: 40px;
				border-left: 2px solid #A50073;
				line-height: 1;
				padding-top: 2px;
				padding-left: 12px;
			}
		}
	}
	.nav_other{
		padding: 40px 0 44px 0;
		background-color: #F7F6F9;
		text-align: center;
		div{
			display: inline-block;
			margin: 0 30px;
			font-size: 20px;
			cursor: pointer;
		}
		div:hover{
			color: #A50073;
		}
	}
}
.search_box{
	width: 100%;
	height: calc(100vh - 90px);
	position: fixed;
	top: 90px;
	left: 0;
	background-color: rgba(0,0,0,.7);
	z-index: 999;
	.search_main{
		padding: 68px 0 80px 0;
		background-color: #F7F6F9;
		.search_el{
			width: 1112px;
			margin: 0 auto;
			position: relative;
			.icon_close{
				position: absolute;
				right: -100px;
				top: -35px;
				cursor: pointer;
			}
			.icon_left{
				position: absolute;
				top: 16px;
			}
			.icon_right{
				position: absolute;
				top: 16px;
				right: 0;
				transform: rotate(-90deg);
				cursor: pointer;
			}
			input{
				width: 100%;
				height: 60px;
				line-height: 60px;
				font-size: 20px;
				border: none;
				border-bottom: 1px solid #A50073;
				color: #A50073;
				padding: 0 38px;
				background-color: transparent;
			}
		}
	}
}
.nav_box{
	width: 100%;
	display: flex;
	align-items: center;
	padding: 0 60px;
	border-bottom: 1px solid #F7F5F7;
	user-select: none;
	background-color: #ffffff;
	.left_box{
		display: flex;
		align-items: center;
		width: auto;
		.nav_main{
			display: inline-block;
			padding-left: 50px;
			.nav_el{
				width: auto;
				min-width: 95px;
				height: 90px;
				line-height: 90px;
				display: inline-block;
				padding: 0 20px;
				font-size: 20px;
				text-align: center;
				cursor: pointer;
				border-top: 4px solid transparent;
			}
			.nav_el:hover{
				color: #A50073;
				border-top: 4px solid #A50073;
			}
			.actived{
				color: #A50073;
				border-top: 4px solid #A50073;
			}
		}
		.logo{
			width: 140px;
			cursor: pointer;
			position: relative;
			top: -6px;
		}
	}
	.right_box{
		flex: 1;
		text-align: right;
		.lang_box{
			display: inline-block;
			margin-left: 30px;
			border: 1px solid #E3E1E6;
			border-radius: 8px;
			div{
				display: inline-block;
				padding: 8px 14px 8px 14px;
				cursor: pointer;
				font-family: Arial;
			}
			.actived{
				color: #A50073;
				font-weight: bold;
			}
		}
	}
}
</style>